import React, { Component } from "react";
import { userService} from '../services/user';

import { teleconsultService } from '../services/teleconsult';
import { doctorService } from '../services/doctor';
import { slotService } from '../services/slot';
import { favouriteService } from '../services/favourite';

import _ from 'lodash';
import '../assets/styles/ProfessionalProfile.scss';
import Carousel from 'react-bootstrap/Carousel';
import Spinner from 'react-bootstrap/Spinner';

import video_icon from '../assets/images/video_icon.png';
import chat_icon from '../assets/images/chat_icon.png';
import mail_icon from '../assets/images/mail_icon.png';
import phone_icon from '../assets/images/phone_icon.png';
// import grab_icon from '../assets/images/grab_icon.png';
// import hotel_icon from '../assets/images/hotel_icon.png';
// import world_icon from '../assets/images/world_icon.png';
import location_pin_outline_icon from '../assets/images/location-pin-outline-icon.png';
import calendar_icon from '../assets/images/calendar-icon.svg';
import clinic_default from '../assets/images/clinic_default.png';
import unfav from '../assets/images/fav-unfill.png';
import fav from '../assets/images/fav-fill.png';
import walk_in_icon from '../assets/images/walk_in_icon.png';

import { arrayService } from '../services/array';
// import profile_img from '../assets/images/profile.png';
import moment from 'moment';
import {Tabs, Tab} from "react-bootstrap";
import default_avatar from '../assets/images/avatar-default.png';
import { BookingModal } from "./BookingModal";
import { SignInModal } from "./SignInModal";
import { SignUpModal } from "./SignUpModal";
import { VerifyPhoneModal } from "./VerifyPhoneModal";
import { HotelDialog } from "./HotelDialog";
import { ScheduleModal } from "./ScheduleModal";
import { NoSlotDialog } from "./NoSlotDialog";
import { CustomMessageDialog } from "./CustomMessageDialog";

import OperationHour from "./OperationHour";
import SEO from './SEO';

class ProfessionalProfile extends Component {

    constructor(props){
        super(props);

        const query = new URLSearchParams(this.props.location.search);

        this.state = {
            loading: false,
            slot_loading: false,
            doctor: {},
            chat_info: {},
            location: {},
            slots: [],
            today_date: moment().startOf('day'),
            slot_date: moment().startOf('day'),
            day_diff: 0,
            key: 'profile',
            showVerifyPhoneModal: false,
            showBookingModal: false,
            showSignInModal: false,
            showSignUpModal: false,
            showHotelDialog: false,
            showScheduleModal: false,
            showNoSlotDialog: false,
            showCustomMessageDialog: false,
            appointment: {
                from: 'prof_profile',
                slot: {},
                doctor: {}
            },
            is_next: query.get('is_next'),
            metadata: {
                title: 'Search & Book - BookDoc',
                description: 'Book appointments via BookDoc now!',
                type: 'website'
            }
        }

        this.handleVerifyPhoneModal = this.handleVerifyPhoneModal.bind(this);
        this.handleBookingModal = this.handleBookingModal.bind(this);
        this.handleSignInModal = this.handleSignInModal.bind(this);
        this.handleSignUpModal = this.handleSignUpModal.bind(this);
        this.handleHotelDialog = this.handleHotelDialog.bind(this);
        this.handleNoSlotDialog = this.handleNoSlotDialog.bind(this);
        this.handleCustomMessageDialog = this.handleCustomMessageDialog.bind(this);
        this.handleScheduleModal = this.handleScheduleModal.bind(this);
        this.getSlots = this.getSlots.bind(this);
        this.get_range_dates = this.get_range_dates.bind(this);
        this.setSelectedSlot = this.setSelectedSlot.bind(this);
        this.onSelectedSlot = this.onSelectedSlot.bind(this);
        this.onFavClick = this.onFavClick.bind(this);
        this.getNextSlots = this.getNextSlots.bind(this);
    }

    handleBookingModal = (isOpen) => this.setState({ showBookingModal: isOpen });
    handleVerifyPhoneModal = (isOpen) => this.setState({ showVerifyPhoneModal: isOpen });
    handleSignInModal = (isOpen) => this.setState({ showSignInModal: isOpen });
    handleSignUpModal = (isOpen) => this.setState({ showSignUpModal: isOpen });
    handleHotelDialog = (isOpen) => this.setState({ showHotelDialog: isOpen });
    handleNoSlotDialog = (isOpen) => this.setState({ showNoSlotDialog: isOpen });
    handleCustomMessageDialog = (isOpen) => this.setState({ showCustomMessageDialog: isOpen });
    handleScheduleModal = (isOpen) => this.setState({ showScheduleModal: isOpen });
    handleSwitchSignInModal  = (isOpen) => this.setState({ showSignInModal: isOpen, showSignUpModal: !isOpen  });
    handleSwitchSignUpModal  = (isOpen) => this.setState({ showSignInModal: !isOpen, showSignUpModal: isOpen });

    getDoctor(doc_friendly_id, location_friendly_id){
        this.setState({
            loading: true
        });
        let params = {
            location_id: location_friendly_id
        }
        doctorService.get(doc_friendly_id,params)
        .then(
            data => {
                if(data){
                    let location = arrayService.findElementByProperty(data.locations, 'friendly_id', this.props.match.params.location_friendly_id);
                    
                    if(location === null || location === undefined){
                        window.location.replace("/search-book/404");
                        return;
                    }
                    
                    if(this.state.is_next === 'true'){
                        this.getNextSlots(location.id,moment(this.state.slot_date).format('YYYYMMDD'));
                    }else{
                        this.getSlots(location.id,moment(this.state.slot_date).format('YYYYMMDD'));
                    }

                    this.getDocChatInfo(data.id);

                    let doctor_name = `${data.title || ''}${data.name}`
                    let doctor_specialties = data.specialties.map(specialty => { if(specialty.verified) return specialty.name; else return null;  }).filter(Boolean).join(', ').replace(/, ([^,]*)$/, ' and $1')
                    
                    if (location.alert_popup_message !== ""){
                        this.handleCustomMessageDialog(true)
                    }
                    this.setState(prevState => ({
                        doctor: data,
                        location: location,
                        appointment: {
                            ...prevState.appointment,
                            doctor: data
                        },
                        metadata: {
                            ...prevState.metadata,
                            title: `Search & Book | ${doctor_name} | ${doctor_specialties} in ${location.state}`,
                            description: `Meet ${doctor_name}, a dedicated ${doctor_specialties} at ${location.name} in ${location.state}. Skip the hassle, book your appointment online today!`
                        }
                    }))
                }
            },
            error => {
                console.log(error)
                this.setState({ error })
            }
        ).then(() => {
            this.setState({
                loading: false
            });
        });
    }

    getDocChatInfo(doctor_id){
        teleconsultService.getDocChatInfo(doctor_id).then(
            data => {
                if(data){
                    this.setState({
                        chat_info: data
                    });
                }
            },
            error => {
                console.log(error)
                this.setState({ error })
            }
        );
    }

    getSlots(location_id, date){
        this.setState({
            slot_loading: true,
            slots: []
        });
        let params = {
            location: location_id,
            date: date,
            around: 1
        }
        slotService.get(params)
        .then(
            data => {
                this.setState({
                    slots: data
                })
            },
            error => {
                console.log(error)
                this.setState({ error })
            }
        ).then(() => {
            this.setState({
                slot_loading: false
            });
        });
    }

    getNextSlots(location_id, date){
        this.setState({
            slot_loading: true,
            slots: []
        });
        let params = {
            location: location_id,
            date: date,
            around: 1
        }
        slotService.next(params)
        .then(
            data => {
                if(_.isEmpty(data)){
                    this.handleNoSlotDialog(true);
                }else{
                    let nextDate = Object.keys(data)[0]
                    let slots = data[nextDate]
                    this.setState({
                        slots: slots
                    })
                    nextDate = moment(nextDate, 'YYYYMMDD').startOf('day')
                    this.setState({
                        slot_date: nextDate,
                        day_diff: nextDate.diff(moment(this.state.today_date), 'days')
                    })
                }
            },
            error => {
                console.log(error)
                this.setState({ error })
            }
        ).then(() => {
            this.setState({
                slot_loading: false
            });
        });
    }

    setTabKey(key){
        this.setState({ key: key})
    }

    componentDidMount(){
        this.getDoctor(this.props.match.params.doc_friendly_id,this.props.match.params.location_friendly_id);
    }

    get_range_dates(is_increase){

        let current_date = moment(this.state.slot_date).startOf('day')

        if(is_increase){
            current_date = moment(current_date).add(1, 'day');
        }else{
            current_date = current_date.subtract(1, "days");
        }

        this.setState({
          slot_date: current_date,
          day_diff: current_date.diff(moment(this.state.today_date), 'days')
        })

       this.getSlots(this.state.location.id, moment(current_date).format('YYYYMMDD'))
    }

    onSelectedSlot(slot){
        this.setSelectedSlot(slot);

        userService.getUser() ? (userService.getUser().verified ? this.handleBookingModal(true) : this.handleVerifyPhoneModal(true)) : this.handleSignInModal(true);
    }

    setSelectedSlot(slot){
        this.setState(prevState => ({
            appointment: {
                ...prevState.appointment,
                slot: slot
            }
        }));
    }

    onFavClick(location_id, isFav){

        let params = {
            practice_location_id: location_id
        }

        favouriteService.favourite(isFav, params)
        .then(
            data => {
                this.setState(prevState => ({
                    doctor: {
                        ...prevState.doctor,
                        favorited: !isFav,
                    },
                    appointment: {
                        ...prevState.appointment,
                        doctor: {
                            ...prevState.appointment.doctor,
                            favorited: !isFav
                        }
                    }
                }))
            },
            error => {
                console.log(error)
                this.setState({ error })
            }
        );
    }

    convertEpochToTime(value){
        return moment.unix(value).utc().format('hh:mm A')
    }

    getDirectionUrl(){
        // return `https://www.google.com/maps/search/?api=1&query=${this.state.location.lat},${this.state.location.long}`
        return `https://www.google.com/maps/dir//${this.state.location.lat},${this.state.location.long}`
    }

    isWalkIn(operating_hours){
        let walkIn = _.find(operating_hours, function(day) {
            return (!day.by_appointment_only && day.open_time);
        });
        return walkIn ? true : false
    }

    requestMail = (doctor) => {
        let subject = 'Request for an Appointment';
        let body = `Hi there,%0D%0A%0D%0A I would like to book an appointment with ${doctor.title || ''} ${doctor.name}. Please find my details below: %0D%0A%0D%0A Name: ${userService.getUser().first_name} ${userService.getUser().last_name} %0D%0A Contact Number: ${userService.getUser().phone} %0D%0A Preferred Date %26 Time: %0D%0A%0D%0A Look forward to your return call. Thanks.`;
        return `mailto:care+d${doctor.id}@bookdoc.com?subject=${subject}&body=${body}`
    }

    linkify(text) {
        var urlRegex =/(\b(https?:\/\/|ftp:\/\/|file:\/\/|www\.)[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig;
        return text.replace(urlRegex, function(url) {
            if (url.startsWith("www.")){
                url = "https://"+url;
            }
            return '<a target="_blank" rel="noopener noreferrer" href="' + url + '">' + url + '</a>';
        });
    }

    render() {
        if(this.state.loading){
            return <div className="loader"><Spinner animation="border" /></div>
        }else{
            if (_.isEmpty(this.state.doctor)){
                return <div className="loader">Invalid doctor page</div>
            }else{
                return (
                    <>
                        <SEO 
                        title={this.state.metadata.title} 
                        description={this.state.metadata.description}
                        type={this.state.metadata.type} />
                        <div className="professional-profile-page container">
                        <div className="header">
                            <h1 className="title">Online Appointment</h1>
                            <div className="bread-crumb">Home / Search & Book / {this.state.doctor.name}</div>
                        </div>
                        <hr className="header-line"/>
                        <div className="body desktop-v">
                            <div className="clinic-details">
                                <div className="img-slider">
                                    <Carousel className="carousel" nextIcon="" nextLabel="" prevIcon="" prevLabel="">
                                        {
                                            this.state.doctor.photos.map((item, index) => (
                                                <Carousel.Item className="carousel-item" key={`expert-${index}`}>
                                                    <img className="d-block w-100" src={item.styles.origin.url} alt={item.alt}/>
                                                </Carousel.Item>
                                            ))
                                        }
                                        {_.isEmpty(this.state.doctor.photos) &&
                                            <Carousel.Item className="carousel-item">
                                                <img className="d-block w-100" src={clinic_default} alt='doctor-img' />
                                            </Carousel.Item>
                                        }
                                    </Carousel>
                                </div>
                                {this.isWalkIn(this.state.location.operating_hours) &&
                                    <div className="consultation-type">
                                        <div className="title">Consultation</div>
                                            <div className="type"><img src={walk_in_icon} className="consultation-icon" alt='consultation-icon'/>Walk In</div>
                                    </div>
                                }
                                <div className="contact">
                                    <div className="title">Contact</div>
                                    <div className="details-container">
                                        <div className="icon-col">
                                            <img className="location-pin-outline-icon" src={location_pin_outline_icon} alt='location-pin-icon' />
                                        </div>
                                        <div className="address-col">
                                            <h2 className="address-name"><a href={`/search-book/clinic/${this.state.location.friendly_id}`}>{this.state.location.name}</a></h2>
                                            <h3 className="address">{this.state.location.address}, {[this.state.location.postal, this.state.location.state].filter(Boolean).join(" ")}</h3>
                                            <div className="map-container">
                                                <iframe title="locationMap" src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_API_KEY}&q=${this.state.doctor.locations[0].lat},${this.state.doctor.locations[0].long}`} className="w-100 h-100" frameBorder="0" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                                            </div>
                                            <a className="direction-tag" href={this.getDirectionUrl()} target="_blank" rel="noreferrer">Get Direction</a>
                                            {userService.getUser() &&
                                                <div className="phone-email-container">
                                                    <a href={`tel:${this.state.doctor.phone_number}`}><img className="contact-icon phone" src={phone_icon} alt='contact-phone' /></a>
                                                    <a href={this.requestMail(this.state.doctor)}><img className="contact-icon mail" src={mail_icon} alt='contact-email' /></a>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="interest">
                                    <div className="title">You might be interested....</div>
                                    <div className="interest-links">
                                        <a className="link-container" target="_blank" href={`grab://open?screenType=BOOKING&dropOffKeywords=${this.state.location.name}&dropOffAddress=${this.state.location.name}&dropOffLatitude=${this.state.location.lat}&dropOffLongitude=${this.state.location.long}&sourceID=CiFLV3RB7N&sourceAppName=BookDoc`}>
                                            <div className="interest-icon">
                                                <img src={grab_icon}/>
                                            </div>
                                            <div className="interest-title">Book A Ride</div>
                                        </a>
                                        <div className="link-container" onClick={() => this.handleHotelDialog(true)}>
                                            <div className="interest-icon">
                                                <img src={world_icon}/>
                                            </div>
                                            <div className="interest-title">Travel Info</div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            <div className="doctor-details">
                                <div className="details-container">
                                    <div className="profile-pic">
                                        <img src={`${this.state.doctor.avatar ? (this.state.doctor.avatar.styles.origin.url) : default_avatar}`} onError={(e) => { e.target.src = default_avatar }} alt='doctor-avatar' />
                                    </div>
                                    <div className="details">
                                        <div className="top-details">
                                        <div className="name-row">
                                            <h2 className="name">{this.state.doctor.title || '' } {this.state.doctor.name}</h2>
                                        </div>
                                        {
                                            this.state.doctor.specialties.map((specialty, index) => (
                                                <div className="specialty" key={`specialty-${index}`}>{specialty.name}</div>
                                            ))
                                        }
                                        <div className="feature-tags">
                                            {this.state.doctor.is_using_calendar === true &&
                                                <div className="feature-tag online-booking">Online Booking</div>
                                            }
                                            {(!_.isEmpty(userService.getUser()) && _.includes(_.map(this.state.doctor.employers, 'id'), _.isEmpty(userService.getUser().employee) ? null : userService.getUser().employee.employer_id)) &&
                                                <div className="feature-tag corporate-panel">Corporate Panel</div>
                                            }
                                        </div>

                                        </div>
                                        <div className="bottom-details">
                                            {userService.getUser() &&
                                                <button className="btn fav-btn" onClick={() => this.onFavClick(this.state.location.id, this.state.doctor.favorited)}>
                                                    { this.state.doctor.favorited ? <img src={fav} alt='favourite' /> : <img src={unfav} alt='unfavourite' /> }
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                                {this.state.doctor.is_using_calendar === true &&
                                    <React.Fragment>
                                        <div className="schedule-walk-in">Schedule</div>
                                        <div className="slots-container">
                                            <div className="date-bar">
                                                <button className={`btn btn-link previous ${this.state.day_diff > 0 ? '' : 'disabled'}`}><i className="fa fa-chevron-left" aria-hidden="true" onClick={() => this.get_range_dates(0)}></i></button>
                                                <div className="date">{moment(this.state.slot_date).format('ddd, DD MMM Y')}</div>
                                                <button className="btn btn-link next" onClick={() => this.get_range_dates(1)}><i className="fa fa-chevron-right" aria-hidden="true"></i></button>
                                            </div>
                                            <div className="slots">
                                                {(() => {
                                                    if (this.state.slot_loading) {
                                                        return <div className="slots-loader"><Spinner animation="border" className="spinner"/></div>;
                                                    } else {
                                                        return (this.state.slots.length ?
                                                            this.state.slots.map((slot, index) => (
                                                            <button key={`slot-${index}`} className="btn slot valid-slot" onClick={() => this.onSelectedSlot(slot)}>{this.convertEpochToTime(slot.start)}</button>
                                                            )) : <div className="slots-loader">
                                                                <div className="availability-row w-100">
                                                                    <div>No Slots</div>
                                                                    <button className="btn btn-link availability-btn" onClick={() => this.getNextSlots(this.state.location.id,moment(this.state.slot_date).format('YYYYMMDD'))}>Click Here For Next Availability</button>
                                                                </div>
                                                            </div>
                                                            );
                                                    }
                                                })()}

                                            </div>
                                        </div>
                                    </React.Fragment>
                                }

                                {/* teleconsult */}
                                {(!_.isEmpty(this.state.chat_info) && this.state.doctor.teleconsult_enabled) &&
                                    <div className="teleconsult-container">
                                        <div className="div-header">
                                            <div className="header-title">Teleconsult (Require App)</div>
                                            <a className="download-app" target="_blank" rel="noreferrer" href={`${process.env.REACT_APP_MAIN_SITE_URL}/download-bookdoc-app/`}>Download App</a>
                                        </div>
                                        <div className="teleconsult-lists">
                                            {this.state.chat_info.chat_enabled &&
                                                <a className="btn btn-link teleconsult-btn chat-btn" href={`${process.env.REACT_APP_DEEPLINK_URL}/teleconsult/doctor/${this.state.doctor.id}`}>
                                                    <div className="teleconsult-icon">
                                                        <img className="chat-icon" src={chat_icon} alt='chat' />
                                                    </div>
                                                    <div className="button-info">
                                                        <div className="info-text">Chat</div>
                                                        <div className="info-price">{`${this.state.chat_info.chat_price.currency} ${this.state.chat_info.chat_price.price.toFixed(2)}`}</div>
                                                    </div>
                                                </a>
                                            }
                                            {this.state.chat_info.video_enabled &&
                                                <a className="btn btn-link teleconsult-btn video-btn" href={`${process.env.REACT_APP_DEEPLINK_URL}/teleconsult/doctor/${this.state.doctor.id}`}>
                                                    <div className="teleconsult-icon">
                                                        <img className="chat-icon" src={video_icon} alt='chat' />
                                                    </div>
                                                    <div className="button-info">
                                                        <div className="info-text">Video</div>
                                                        <div className="info-price">{`${this.state.chat_info.chat_price.currency} ${this.state.chat_info.chat_price.video_price.toFixed(2)}`}</div>
                                                    </div>
                                                </a>
                                            }
                                        </div>
                                    </div>
                                }
                                {/* end teleconsult */}

                                <hr className="details-line"/>

                                <div className="details-tabs-container">
                                    <Tabs id="controlled-details-tabs" activeKey={this.state.key} onSelect={(k) => this.setTabKey(k)}>
                                        <Tab eventKey="profile" title="Profile">
                                            {this.state.doctor.summary &&
                                                <div className="detail-container">
                                                    <h3 className="tab-title">Summary</h3>
                                                    <h4 className="tab-content" dangerouslySetInnerHTML={{ __html: this.linkify(this.state.doctor.summary) }}></h4>
                                                </div>
                                            }
                                            {this.state.doctor.educations.length > 0 &&
                                                <div className="detail-container">
                                                    <div className="sub-tab-title">Education</div>
                                                    <ul className="tab-content list">
                                                    {
                                                        this.state.doctor.educations.map((education, index) => (
                                                            <li key={`edu-${index}`}>{education.name}</li>
                                                        ))
                                                    }
                                                    </ul>
                                                </div>
                                            }

                                            <div className="detail-container">
                                                <div className="sub-tab-title">Credentials</div>
                                                <div className="tab-content credential">
                                                    <div className="cre-title">Qualifications</div>
                                                    <div className="punctuation">:</div>
                                                    <div className="cre-content">{this.state.doctor.qualifications.map(({name}) => name).join(', ') || '-'}</div>
                                                </div>
                                                {this.state.doctor.mmc &&
                                                    <div className="tab-content credential">
                                                        <div className="cre-title">Medical Registration Number</div>
                                                        <div className="punctuation">:</div>
                                                        <div className="cre-content">{this.state.doctor.mmc}</div>
                                                    </div>
                                                }
                                                {this.state.doctor.nsr &&
                                                    <div className="tab-content credential">
                                                        <div className="cre-title">National Specialist Registry Number</div>
                                                        <div className="punctuation">:</div>
                                                        <div className="cre-content">{this.state.doctor.nsr}</div>
                                                    </div>
                                                }

                                            </div>
                                            {this.state.doctor.languages &&
                                                <div className="detail-container">
                                                    <div className="sub-tab-title">Language</div>
                                                    <p className="tab-content">{this.state.doctor.languages.replace(/,/g, ', ')}</p>
                                                </div>
                                            }
                                        </Tab>
                                        {/* <Tab eventKey="services" title="Services">
                                            <div className="detail-container">
                                                <h3 className="tab-title">Services/Procedures</h3>
                                                <ul className="tab-content list">
                                                    {
                                                        this.state.doctor.services.map((service, index) => (
                                                            <li key={`service-${index}`}><h4 className="service-item">{service.name}</h4></li>
                                                        ))
                                                    }
                                                </ul>
                                            </div>
                                        </Tab> */}
                                        <Tab eventKey="hours" title="Hours">
                                            <div className="detail-container">
                                                <div className="sub-tab-title">{this.state.location.name}</div>
                                                <OperationHour operatingHours={this.state.location.operating_hours} />
                                                {this.state.location.clinic_hour_note &&
                                                    <div className="hour-note">*Notes: {this.state.location.clinic_hour_note}</div>
                                                }
                                            </div>
                                        </Tab>
                                        {this.state.doctor.insurances.length > 0 &&
                                            <Tab eventKey="insurances" title="Insurances">
                                                <div className="detail-container">
                                                    <h3 className="tab-title">Insurances</h3>
                                                    <ol className="tab-content list">
                                                        {
                                                            this.state.doctor.insurances.map((insurance, index) => (
                                                                <li key={`insurance-${index}`}><h4 className="service-item">{insurance.name}</h4></li>
                                                            ))
                                                        }
                                                    </ol>
                                                </div>
                                            </Tab>
                                        }
                                    </Tabs>
                                </div>
                            </div>
                        </div>

                        <div className="body mobile-v">
                            <div className="clinic-details">
                                <div className="img-slider">
                                    <Carousel className="carousel" nextIcon="" nextLabel="" prevIcon="" prevLabel="">
                                        {
                                            this.state.doctor.photos.map((item, index) => (
                                                <Carousel.Item className="carousel-item" key={`expert-${index}`}>
                                                    <img className="d-block w-100" src={item.styles.origin.url} alt={item.alt}/>
                                                </Carousel.Item>
                                            ))
                                        }
                                        {_.isEmpty(this.state.doctor.photos) &&
                                            <Carousel.Item className="carousel-item">
                                                <img className="d-block w-100" src={clinic_default} alt='doctor-img' />
                                            </Carousel.Item>
                                        }
                                    </Carousel>
                                    {userService.getUser() &&
                                        <button className="btn fav-btn" onClick={() => this.onFavClick(this.state.location.id, this.state.doctor.favorited)}>
                                            { this.state.doctor.favorited ? <img src={fav} alt='favourite' /> : <img src={unfav} alt='unfavourite' /> }
                                        </button>
                                    }
                                    <div className="doctor-details">
                                        <div className="details-container">
                                            <div className="profile-pic">
                                                <img src={`${this.state.doctor.avatar ? (this.state.doctor.avatar.styles.origin.url) : default_avatar}`} onError={(e) => { e.target.src = default_avatar }} alt='doctor-avatar' />
                                            </div>
                                            <div className="details">
                                                <div className="name-row">
                                                    <h2 className="name">{this.state.doctor.name}</h2>
                                                </div>
                                                {
                                                    this.state.doctor.specialties.map((specialty, index) => (
                                                        <div className="specialty" key={`specialty-${index}`}>{specialty.name}</div>
                                                    ))
                                                }
                                                <div className="feature-tags">
                                                    {this.state.doctor.is_using_calendar === true &&
                                                        <div className="feature-tag online-booking">Online Booking</div>
                                                    }
                                                     {(!_.isEmpty(userService.getUser()) && _.includes(_.map(this.state.doctor.employers, 'id'), _.isEmpty(userService.getUser().employee) ? null : userService.getUser().employee.employer_id)) &&
                                                        <div className="feature-tag corporate-panel">Corporate Panel</div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="doctor-details">
                                <div className="details-tabs-container">
                                    <Tabs id="controlled-details-tabs" activeKey={this.state.key} onSelect={(k) => this.setTabKey(k)}>
                                        <Tab eventKey="profile" title="Profile">
                                            {this.state.doctor.summary &&
                                                <div className="detail-container">
                                                    <h3 className="tab-title">Summary</h3>
                                                    <h4 className="tab-content" dangerouslySetInnerHTML={{ __html: this.linkify(this.state.doctor.summary) }}></h4>
                                                </div>
                                            }
                                            {this.state.doctor.educations.length > 0 &&
                                                <div className="detail-container">
                                                    <div className="sub-tab-title">Education</div>
                                                    <ul className="tab-content list">
                                                    {
                                                        this.state.doctor.educations.map((education, index) => (
                                                            <li key={`edu-${index}`}>{education.name}</li>
                                                        ))
                                                    }
                                                    </ul>
                                                </div>
                                            }

                                            <div className="detail-container">
                                                <div className="sub-tab-title">Credentials</div>
                                                <div className="tab-content credential">
                                                    <div className="cre-title">Qualifications</div>
                                                    <div className="punctuation">:</div>
                                                    <div className="cre-content">{
                                                    this.state.doctor.qualifications.map(({name}) => name).join(', ') || '-'}</div>
                                                </div>
                                                {this.state.doctor.mmc &&
                                                    <div className="tab-content credential">
                                                        <div className="cre-title">Medical Registration Number</div>
                                                        <div className="punctuation">:</div>
                                                        <div className="cre-content">{this.state.doctor.mmc}</div>
                                                    </div>
                                                }
                                                {this.state.doctor.nsr &&
                                                    <div className="tab-content credential">
                                                        <div className="cre-title">National Specialist Registry Number</div>
                                                        <div className="punctuation">:</div>
                                                        <div className="cre-content">{this.state.doctor.nsr}</div>
                                                    </div>
                                                }

                                            </div>
                                            {this.state.doctor.languages &&
                                                <div className="detail-container">
                                                    <div className="sub-tab-title">Language</div>
                                                    <p className="tab-content">{this.state.doctor.languages.replace(/,/g, ', ')}</p>
                                                </div>
                                            }
                                        </Tab>
                                        {/* <Tab eventKey="services" title="Services">
                                            <div className="detail-container">
                                                <h3 className="tab-title">Services/Procedures</h3>
                                                <ul className="tab-content list">
                                                    {
                                                        this.state.doctor.services.map((service, index) => (
                                                            <li key={`service-${index}`}><h4 className="">{service.name}</h4></li>
                                                        ))
                                                    }
                                                </ul>
                                            </div>
                                        </Tab> */}
                                        <Tab eventKey="hours" title="Hours">
                                            <div className="detail-container">
                                                <div className="sub-tab-title">{this.state.location.name}</div>
                                                <OperationHour operatingHours={this.state.location.operating_hours} />
                                                {this.state.location.clinic_hour_note &&
                                                    <div className="hour-note">*Notes: {this.state.location.clinic_hour_note}</div>
                                                }
                                            </div>
                                        </Tab>
                                    </Tabs>
                                </div>

                                <hr className="mobile-details-line"/>

                                {this.state.doctor.is_using_calendar === true &&
                                    <div className="slots-container">
                                        <div className="schedule-div">
                                            <div className="schedule-title">
                                                Schedule
                                            </div>
                                            <div className="schedule-show" onClick={() => this.handleScheduleModal(true)}>Show All</div>
                                        </div>
                                        <div className="mobile-date-bar">
                                            <img src={calendar_icon} alt='calendar' />
                                            <div className="date">{moment(this.state.slot_date).format('ddd, DD MMM Y')}</div>
                                        </div>
                                        <div className="slots">
                                            {(() => {
                                                if (this.state.slot_loading) {
                                                    return <div className="slots-loader"><Spinner animation="border" className="spinner"/></div>;
                                                } else {
                                                    return (this.state.slots.length ?
                                                        this.state.slots.map((slot, index) => (
                                                            <button key={`slot-${index}`} className="btn slot valid-slot" onClick={() => this.onSelectedSlot(slot)}>{this.convertEpochToTime(slot.start)}</button>
                                                        )) : <div className="slots-loader">
                                                            <div className="availability-row w-100">
                                                                <div>No Slots</div>
                                                                <button className="btn btn-link availability-btn" onClick={() => this.getNextSlots(this.state.location.id,moment(this.state.slot_date).format('YYYYMMDD'))}>Click Here For Next Availability</button>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            })()}
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className="clinic-details">
                                <div className="contact">
                                        <div className="title">Contact</div>
                                        <div className="details-container">
                                            <div className="icon-col">
                                                <img className="location-pin-outline-icon" src={location_pin_outline_icon} alt='location-pin' />
                                            </div>
                                            <div className="address-col">
                                                <h2 className="address-name"><a href={`/search-book/clinic/${this.state.location.friendly_id}`}>{this.state.location.name}</a></h2>
                                                <h3 className="address">{this.state.location.address}, {[this.state.location.postal, this.state.location.state].filter(Boolean).join(" ")}</h3>
                                                <div className="map-container">
                                                    <iframe title="locationMap2" src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_API_KEY}&q=${this.state.doctor.locations[0].lat},${this.state.doctor.locations[0].long}`} className="w-100 h-100" frameBorder="0" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                                                </div>
                                                <a className="direction-tag" href={this.getDirectionUrl()} target="_blank" rel="noreferrer">Get Direction</a>
                                                {userService.getUser() && 
                                                    <div className="phone-email-container">
                                                        <a href={`tel:${this.state.doctor.phone_number}`}><img className="contact-icon phone" src={phone_icon} alt='contact-phone' /></a>
                                                        <a href={this.requestMail(this.state.doctor)}><img className="contact-icon mail" src={mail_icon} alt='contact-email' /></a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="mobile-details-line"/>
                                    {/* <div className="interest">
                                        <div className="title">You might be interested....</div>
                                        <div className="interest-links">
                                            <a className="link-container" target="_blank" href={`grab://open?screenType=BOOKING&dropOffKeywords=${this.state.location.name}&dropOffAddress=${this.state.location.name}&dropOffLatitude=${this.state.location.lat}&dropOffLongitude=${this.state.location.long}&sourceID=CiFLV3RB7N&sourceAppName=BookDoc`}>
                                                <div className="interest-icon">
                                                    <img src={grab_icon}/>
                                                </div>
                                                <div className="interest-title">Book A Ride</div>
                                            </a>
                                            <div className="link-container" onClick={() => this.handleHotelDialog(true)}>
                                                <div className="interest-icon">
                                                    <img src={world_icon}/>
                                                </div>
                                                <div className="interest-title">Travel Info</div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>

                                <div className="doctor-details">
                                {/* teleconsult */}
                                {!_.isEmpty(this.state.chat_info) &&
                                    <div className="teleconsult-container">
                                        <div className="teleconsult-lists">
                                            {this.state.chat_info.chat_enabled &&
                                                <a className="btn btn-link teleconsult-btn chat-btn" href={`${process.env.REACT_APP_DEEPLINK_URL}/teleconsult/doctor/${this.state.doctor.id}`} target="_blank" rel="noreferrer">
                                                    <div className="teleconsult-icon">
                                                        <img className="chat-icon" src={chat_icon} alt='chat' />
                                                    </div>
                                                    <div className="button-info">
                                                        <div className="info-text">Chat</div>
                                                        <div className="info-price">{`${this.state.chat_info.chat_price.currency} ${this.state.chat_info.chat_price.price.toFixed(2)}`}</div>
                                                    </div>
                                                </a>
                                            }
                                            {this.state.chat_info.video_enabled &&
                                                <a className="btn btn-link teleconsult-btn video-btn" href={`${process.env.REACT_APP_DEEPLINK_URL}/teleconsult/doctor/${this.state.doctor.id}`} target="_blank" rel="noreferrer">
                                                    <div className="teleconsult-icon">
                                                        <img className="chat-icon" src={video_icon} alt='chat' />
                                                    </div>
                                                    <div className="button-info">
                                                        <div className="info-text">Video</div>
                                                        <div className="info-price">{`${this.state.chat_info.chat_price.currency} ${this.state.chat_info.chat_price.video_price.toFixed(2)}`}</div>
                                                    </div>
                                                </a>
                                            }
                                        </div>
                                    </div>
                                }
                                {/* end teleconsult */}
                            </div>

                        </div>

                        {userService.getUser() &&
                            <React.Fragment>
                                <VerifyPhoneModal showVerifyPhoneModal={this.state.showVerifyPhoneModal} handleVerifyPhoneModal={this.handleVerifyPhoneModal} handleBookingModal={this.handleBookingModal}/>
                                <BookingModal showBookingModal={this.state.showBookingModal} handleBookingModal={this.handleBookingModal} selected={this.state.appointment} slots={this.state.slots} location={this.state.location} get_range_dates={this.get_range_dates} slot_date={this.state.slot_date} day_diff={this.state.day_diff} setSelectedSlot={this.setSelectedSlot} slot_loading={this.state.slot_loading} onFav={this.onFavClick}/>
                            </React.Fragment>
                        }
                        <React.Fragment>
                            <SignInModal showSignInModal={this.state.showSignInModal} handleSignInModal={this.handleSignInModal} handleSwitchSignUpModal={this.handleSwitchSignUpModal}/>
                            <SignUpModal showSignUpModal={this.state.showSignUpModal} handleSignUpModal={this.handleSignUpModal} handleSwitchSignInModal={this.handleSwitchSignInModal}/>
                            <HotelDialog showHotelDialog={this.state.showHotelDialog} handleHotelDialog={this.handleHotelDialog} doctor={this.state.doctor} location={this.state.location} />
                            <ScheduleModal showScheduleModal={this.state.showScheduleModal} handleScheduleModal={this.handleScheduleModal} slots={this.state.slots} onSelectedSlot={this.onSelectedSlot}  get_range_dates={this.get_range_dates} slot_date={this.state.slot_date} day_diff={this.state.day_diff} slot_loading={this.state.slot_loading} location={this.state.location} getNextSlots={this.getNextSlots}/>
                            <NoSlotDialog showNoSlotDialog={this.state.showNoSlotDialog} handleNoSlotDialog={this.handleNoSlotDialog} />
                            <CustomMessageDialog showCustomMessageDialog={this.state.showCustomMessageDialog} customMessage={this.state.location.alert_popup_message} handleCustomMessageDialog={this.handleCustomMessageDialog} />
                        </React.Fragment>
                    </div>
                    </>
                    
                );
            };
        }
    }
}

export { ProfessionalProfile };
